/* This file is for giving ids to requests to data providers.
We tie the counter to each request, and when we get a response we make sure that the counter has not been updated.
If the counter had been updated before we get the response, it means the response is no longer what the user is
looking for, so we do not load the items.

Note: It looks like this should be in the getFileProviderItems util, or like the logic should be contained entirely in
the  loadMoreItemsForSelectedProvider action. It cannot be in either of these, because they are called when we load more
items due to scrolling (pagination), and in this case we do not want to update the counter in this case (since we may have several requests,
and care about the responses for all of them).
*/

let counter = 0;

export default function getFileProviderItemsRequestCount(): number {
    return counter;
}

function getNextRequestCount(): number {
    return counter + 1;
}

export function incrementGetFileProviderItemsRequestCount() {
    counter = getNextRequestCount();
}
